import { gameSystems } from "@/data/globals";
import useIsDarkMode from "@/hooks/framework/useIsDarkMode";
import useNavigate from "@/hooks/framework/useNavigate";
import TrackingService from "@/services/framework/TrackingService";
import AddIcon from "@mui/icons-material/Add";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { Button, Stack } from "@mui/material";
import { useSearchParams } from "next/navigation";

type Props = {
  fleetId: string;
  mdScreen: boolean;
};

export default function FleetInfoActions({ fleetId, mdScreen }: Props) {
  const isDarkMode = useIsDarkMode();
  const navigate = useNavigate();
  const searchParams = useSearchParams();
  const append = searchParams.get("append") === "true";

  const pdfUrl = (id) => `/armyInfo/${id}/1/preview`;

  const handlePdfClick = () => {
    const url = pdfUrl(fleetId);
    TrackingService.TrackEvent("/pdf/" + fleetId, fleetId + " pdf");
    window.open(url, "_blank");
  };

  const createList = () => {
    navigate((query) => ({
      path: `/list/${gameSystems.ftl.slug}/settings`,
      query
    }));
  };

  const selectList = () => {
    navigate((query) => ({
      path: `/community-lists/${gameSystems.ftl.slug}/${fleetId}`,
      query
    }));
  };

  return (
    <>
      <Stack
        direction="row"
        sx={{
          alignItems: "stretch"
        }}
      >
        <Button id="btnCreateList" variant="contained" sx={{ flex: 1 }} onClick={createList}>
          <AddIcon sx={{ mr: 1 }} />
          {append ? <span>Add Fleet</span> : <span>Create New List</span>}
        </Button>
      </Stack>
      {!append && (
        <Stack
          direction="row"
          spacing={2}
          sx={{
            alignItems: "stretch",
            mt: 1
          }}
        >
          <Button
            color={(mdScreen ? (!isDarkMode ? "white" : "primary") : "primary") as any}
            variant="outlined"
            sx={{ flex: 1 }}
            onClick={handlePdfClick}
          >
            <PictureAsPdfOutlinedIcon sx={{ mr: 1 }} />
            <span>PDF</span>
          </Button>
          <Button
            id="btnSelectList"
            color={(mdScreen ? (!isDarkMode ? "white" : "primary") : "primary") as any}
            variant="outlined"
            sx={{ flex: 3.33 }}
            onClick={selectList}
          >
            <FormatListBulletedIcon sx={{ mr: 1 }} />
            <span>Ready-to-Play Lists</span>
          </Button>
        </Stack>
      )}
    </>
  );
}
